import {IconName} from '../../../../../../libs/shared/ui/src/components/icon/icon';

export enum QuickInsertDropdownsEnum {
  CHOOSE_COMMAND = 'CHOOSE_COMMAND',
  TEMPLATE = 'TEMPLATE',
  SCHEDULING_LINK = 'SCHEDULING_LINK',
}

export enum QuickInsertCommandsEnum {
  TEMPLATE = 'TEMPLATE',
  SCHEDULING_LINK = 'SCHEDULING_LINK',
}

export type QuickInsertCommand = '/template' | '/schedule';

export interface QuickInsertCommandSpec {
  type: QuickInsertCommandsEnum;
  // Command names are untranslated literals.
  name: QuickInsertCommand;
  description: React.ReactNode;
  iconName: IconName;
  iconLabel: React.ReactNode;
}

export interface QuickInsertSelectedCommand {
  command: QuickInsertCommandsEnum;
  input: string;
}
